import React, {useState, useEffect, useCallback} from "react";
import { NavLink as NavLinkRRD } from "react-router-dom";
import { useSelector } from 'react-redux';
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse, Nav, Navbar, NavItem, NavLink } from "reactstrap";
import IcoMoon from 'react-icomoon';
import IconSet from '../../assets/selection.json';
import { withRouter } from "react-router-dom";
const Sidebar = ({
                   routes = [{}],
                   toggleSidenav = () => {},
                   toggleSubmenu = () => {},
                   withoutSub = () => {},
                   width = 0,
                   clickedMenu = null,
                   location,
                   rtlActive = false,
                 }) => {

  // Redux state
  const permissions = useSelector(state => state.getState.permissions);
  const permissionGroups = useSelector(state => state.getState.permissionGroups);
  const authUserTeam = useSelector(state => state.getState.authUserTeam);
  const routeCan = useSelector(state => state.getState.routeCan);
  const roles = useSelector(state => state.getState.roles);
  const [collapseStates, setCollapseStates] = useState({});

  useEffect(() => {
      setCollapseStates(getCollapseStates(routes));
  }, [routes]);
    const getCollapseStates = (routes) => {
        return routes.reduce((acc, route) => {
            if (route.collapse) {
                return {
                    ...acc,
                    [route.state]: getCollapseInitialState(route.views),
                    ...getCollapseStates(route.views)
                };
            }
            return acc;
        }, {});
    };
  // Helper functions
  const activeRoute = (routeName, subMenu = false) => {
    const isActive = location.pathname.includes(routeName) ? "active" : "";
    return isActive + (subMenu ? ' sidenav-sub-menu' : '');
  };

  const hasPermission = (_permissions) => _permissions.some(p => permissions?.includes(p));
  const hasPermissionGroup = (_permissions) => _permissions.some(p => permissionGroups?.includes(p));

  const hasRole = (_roles) =>
      _roles.some(r => roles?.includes(r));

  const hasCan = (can) => routeCan?.[can];

  const getCollapseInitialState = (routes) =>  {
      for (let i = 0; i < routes.length; i++) {
          if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
              return true;
          } else if (window.location.href.indexOf(routes[i].path) !== -1) {
              return true;
          }
      }
      return false;
  }





  // Handlers
  const handleCollapseToggle = (stateKey) => {
    setCollapseStates(prev => ({
      ...Object.fromEntries(Object.keys(prev).map(key => [key, false])),
      [stateKey]: !prev[stateKey]
    }));
    toggleSubmenu({ [stateKey]: !collapseStates[stateKey] });
  };

  const closeSidebar = (name) => {
    if (name === 'Dashboard') withoutSub();
    if (window.innerWidth < 1200) toggleSidenav();
  };
  const  closeSidenav = (name) => {
    if (name === 'Dashboard') {
      withoutSub()
    }
    if (window.innerWidth < 1200) {
      toggleSidenav();
    }
  };
  // Create navigation links
  const createLinks = (routes) => {
    return routes.filter(item => !item.hidden).map((prop, key) => {
      if (prop.hide && hasRole(prop.hide)) return null;
      if (!permissions || !routeCan || !roles) return null;
      if (prop.permission === 'hidden') return null;
      if (prop.name === 'NavHidden') return null;
      if (prop.redirect) return null;
      if (prop.permissionGroup && !hasPermissionGroup(prop.permissionGroup)) return null;

      // Permission checks
      if (
          (prop.permission && !hasPermission(prop.permission)) ||
          (prop.role && !hasRole(prop.role)) ||
          (prop.can && !hasCan(prop.can)) ||
          (prop.authUserTeam !== undefined && prop.authUserTeam !== authUserTeam)
      ) return null;
      if (prop.collapse) {
        const isOpen = collapseStates[prop.state];
        return (
            <React.Fragment key={key}>
              <NavItem
                  className={width > 833 && clickedMenu?.name === prop.name ? "nav-active" : "nav-inactive"}>
                <NavLink
                    href="#"
                    data-toggle="collapse"
                    aria-expanded={isOpen}
                    onClick={(e) => {
                      e.preventDefault();
                      handleCollapseToggle(prop.state);
                    }}
                    className={classnames({ active: getCollapseInitialState(prop.views) })}
                >
                  <div className={`d-flex align-items-center ${width > 833 ? 'flex-column' : ''}`}>
                    <IcoMoon
                        className={classnames({
                          'icon-active': width > 833 && clickedMenu?.name === prop.name,
                          'icon-passive': !(width > 833 && clickedMenu?.name === prop.name)
                        })}
                        iconSet={IconSet}
                        icon={prop.icon}
                        size={24}
                    />
                    <span className={classnames("menus", {
                      "nav-text-active": width > 833 && clickedMenu?.name === prop.name,
                      "nav-text-inactive": !(width > 833 && clickedMenu?.name === prop.name)
                    })}>
                    {prop.name}
                  </span>
                  </div>
                </NavLink>
                {width < 833 && (
                    <Collapse isOpen={isOpen}>
                      <Nav className="nav-sm flex-column">
                        {createLinks(prop.views)}
                      </Nav>
                    </Collapse>
                )}
              </NavItem>
            </React.Fragment>
        );
      }

      return (
          <NavItem
              className={activeRoute(prop.layout + prop.path, prop?.subMenu)}
              key={key}
          >
            <NavLink
                to={prop.layout + prop.path}
                activeClassName=""
                className={(width > 833 && (location?.pathname === prop.layout + prop.path) ? 'nav-active' : 'nav-inactive')}
                onClick={()=>{
                  closeSidenav(prop.name)
                }}
                tag={NavLinkRRD}
            >

              {prop.icon !== undefined ?
                  width > 833 ?
                      <div className={'d-flex flex-column align-items-center'}>
                        <IcoMoon
                            className={`${prop?.subMenu ? 'ml-3 ' : ''} ${ width > 833 && location?.pathname === (prop.layout + prop.path) ? 'icon-active' : 'icon-passive'}`}
                            iconSet={IconSet}
                            icon={prop.icon}
                            size={24}
                        />
                        <span className={`nav-link-text  ${width > 833 && location?.pathname === prop.layout + prop.path ? ' nav-text-active' : ' nav-text-inactive'}`}>{prop.name}</span>
                      </div> :
                      <>
                        <IcoMoon
                            className={`${prop?.subMenu && 'ml-3'}`}
                            iconSet={IconSet}
                            icon={prop.icon}
                            size={24}
                        />
                        <span className="nav-link-text">{prop.name}</span>
                      </>

                  : prop.miniName !== undefined ? (
                      <>
                        <span className="sidenav-mini-icon"> {prop.miniName} </span>
                        <span className="sidenav-normal"> {prop.name} </span>
                      </>
                  ) : (
                      prop.name
                  )}
            </NavLink>
          </NavItem>
      );
    });
  };
  const scrollBarInner= () => {
    return  <div className="scrollbar-inner">
      {width < 833 ? (
          <>
            <div className="d-flex align-items-center">
              <div className="navbar-inner mt-2">
                <IcoMoon
                    className={'cursor-pointer'}
                    iconSet={IconSet}
                    icon={'GRS_Logo'}
                    width={'80px'}
                    height={'40px'}
                />
              </div>
            </div>
            <div className="navbar-inner">
              <Collapse navbar isOpen={true}>
                <Nav navbar>{createLinks(routes)}</Nav>
                <hr className="my-3" />
              </Collapse>
            </div>
          </>
      ) : (
          <div className="d-flex justify-content-between w-100">
            <Collapse isOpen={true}>
              <Nav>{createLinks(routes)}</Nav>
            </Collapse>
          </div>
      )}
    </div>

  };

  return (
      <div>
        <Navbar
            className={
                "pb-0 pt-0 navbar-expand-xs navbar-light bg-white " +
                (rtlActive ? "" : "fixed-left") +
                (width < 833 ? " sidenav navbar-vertical" : "")
            }
        >
          {
            scrollBarInner()
          }
        </Navbar>
      </div>
  );
};

export default withRouter(Sidebar);